const Legal = {
  privacyPolicy: 'a7d892a7-12ae-464d-8b60-e9f0a2fa6064',
  termsAndConditions: '2b2e10b8-2385-44bb-a506-045b7422df6e',

};

export default Legal;
